import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/headerInternal'
import Footer from '../components/footer'
import Nav from '../components/navInterno'
import './index.css'

export default class Internal extends React.Component {
  render(){
    let data = this.props.data;
    let location = this.props.location.pathname;
    
    var info_helmet = {
      title: 'Ultras Mundial, Racismo en la otra cara del Mundial de Rusia 2018.',
      description: 'Conoce a través de varios capítulos la otra cara que trae la Copa Mundial de Rusia 2018. Una serie de episodios para seguir la problemática de los ultras, el racismo y la violencia en el Mundial.',
      keywords: 'ultras, ultras mundial, racismo, mundial, mundial de rusia, mundial rusia 2018, ultras rusia, racismo mundial rusia, violencia mundial rusia',
      image: 'https://cdn4.uvnimg.com/f5/41/b62992a24e6aab94cd3a4a293a42/portada.jpg'
    };
    for (let index = 0; index < data.allSitePage.edges.length; index++) {
      const _page = data.allSitePage.edges[index];
      
      if(_page.node.path == location)
      {
        info_helmet.title = _page.node.context.node.title;
        info_helmet.description = _page.node.context.node.description;
        info_helmet.image = _page.node.context.node.article_sharing[0].sharing_image;
        break;
      }
    }
    return (
      <div>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'title', content: info_helmet.title },
            { name: 'description', content: info_helmet.description },
            { name: 'keywords', content: 'ultras, ultras mundial, racismo, mundial, mundial de rusia, mundial rusia 2018, ultras rusia, racismo mundial rusia, violencia mundial rusia' },
            { name: 'og:title', content: info_helmet.title },
            { name: 'og:description', content: info_helmet.description },
            { name: 'og:image', content: info_helmet.image },
            { name: 'og:url', content: 'https://www.univision.com' + location },
            { name: 'twitter:title', content: info_helmet.title },
            { name: 'twitter:description', content: info_helmet.description },
            { name: 'twitter:image', content: info_helmet.image },
            { name: 'twitter:card', content: 'summary_large_image' },
          ]}
        />
        <Header Pages={data.allSitePage.edges}/>
        <div className="contiene_internal">
          {this.props.children()}
        </div>
        <Nav Pages={data.allSitePage.edges} location={location} />
        <Footer />
      </div>
    )
  }
}

export const query = graphql`
  query SiteTitleQueryInternal {
    site {
      siteMetadata {
        title
      }
    }
    allSitePage{
      edges {
        node {
          id
          path
          context 
          {
            slug
            node{
              title
              description
              publishDate
              type
              index
              author_name
              author_image
              image_lead
              label
              article_sharing{
                sharing_image
              }
            }
          }
        }
      }
    }
  }`



// WEBPACK FOOTER //
// ./src/layouts/internal.js